import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { SubscriptionsManagement } from '../../components/admin/SubscriptionsManagement';

export function SubscriptionsPage() {
  return (
    <AdminLayout
      title="Abonnements"
      description="Gérez les abonnements et souscriptions"
    >
      <SubscriptionsManagement />
    </AdminLayout>
  );
}
